import { Component, Input } from '@angular/core';
@Component({
    selector: "page-top-menu",
    templateUrl: "topmenu.component.html"
})

export class TopMenuComponent {
	@Input() name: String;
    //@Input() name: String;
}